import React, {  useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgetPassword = () => 
{ 
     
  const [inputs, setInputs] = useState({});
  const [showSendOtpBtn,setShowSendOtpBtn]= useState(false);
  const [showResendOtpBtn,setShowResendOtpBtn]= useState(true);
  let [fpOtp,setFpOtp]=useState(1111);
  const [showFPDiv,setShowFPDiv]=useState(false);
  const [showRPDiv,setShowRPDiv]=useState(true);
  
  
  const changeFPHandler = (e) => {
       
       
         if(e.target.name==='fMobile' )
        {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
             const name = e.target.name;             
             const value = e.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['fMobile']: ""}))
              
        }
        
        }
      
        else
        {
            const name = e.target.name;
            const value = e.target.value;
            setInputs(values => ({...values, [name]: value}))
        }
       
      
  
    }
    const onClickSendOtp=()=>{                 
                             
            if((!inputs.fMobile) || inputs.fMobile ==='')
             {
        
                  toast.error("Mobile number is required.",{ position: "bottom-right", autoClose: 4000, theme: "light"});          
                  return;
                }
                else
                {
                         var mlurl="https://userauth.avtbharat.com/Authorization/MobileLogin";
                         const sotpparams = JSON.stringify({ "MobileNumber": inputs.fMobile });
                         axios.post(mlurl, sotpparams,{
                          "headers": {
                          "content-type": "application/json",
                        },
                      })
                     .then(function(response)
                     { 
                          
                          if(JSON.parse(JSON.stringify(response.data.validStatus))===true)
                            {   
                                setShowSendOtpBtn(true);
                                setShowResendOtpBtn(false); 
                                
                                console.log(response.data.message);
                                var length=4;
                                let myOtp= Math.floor(Math.pow(10, length-1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length-1) - 1));
                                setFpOtp(myOtp);
                                const fpMobile= inputs.fMobile;
                                var sendsmurl=`https://smsapi.edumarcsms.com/api/v1/sendsms?message=Enter%20the%20code%20${myOtp}%20to%20verify%20your%20phone%20number%20with%20AVTBharat.%20Avaal%20Technologies%20India%20Pvt%20Ltd&senderId=AVLTEC&templateId=1007075396419861493&number=${fpMobile}&apikey=clji9namy0007j1qx2cy21d7q`;
                                //alert(sendsmurl);
                                axios.post(sendsmurl).then(response => 
                                {
                                       console.log(response.data.success);
                                       if(response.data.success===true)
                                       {
                                            toast.success("OTP send successfully.",{ position: "bottom-right", autoClose: 4000, theme: "light"});                                     
                                       }                               
                                       
                                }) .catch(function(error)
                                {
                                     console.log(error.message);
                                });                  
                           }
                            else
                            {
                             
                                setShowSendOtpBtn(false);
                                setShowResendOtpBtn(true); 
                                
                                toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"}); 
                                                        
                            }
                     })
                    .catch(function(error)
                    {
                            setShowSendOtpBtn(false);
                            setShowResendOtpBtn(true); 
                            console.log(error.message);
                    });        
                                  
                   
                }

    }

    
    const onClickResendOtp=()=>{
      var length=4;
                 let myOtp1= Math.floor(Math.pow(10, length-1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length-1) - 1));
                 setFpOtp(myOtp1);
                 const fpMobile1= inputs.fMobile;
                 var sendsmurl1=`https://smsapi.edumarcsms.com/api/v1/sendsms?message=Enter%20the%20code%20${myOtp1}%20to%20verify%20your%20phone%20number%20with%20AVTBharat.%20Avaal%20Technologies%20India%20Pvt%20Ltd&senderId=AVLTEC&templateId=1007075396419861493&number=${fpMobile1}&apikey=clji9namy0007j1qx2cy21d7q`;
                         
                 axios.post(sendsmurl1).then(response => 
                 {
                                       console.log(response.data.success);
                                       if(response.data.success===true)
                                       {
                                            
                                             toast.success("OTP send successfully.",{ position: "bottom-right", autoClose: 4000, theme: "light"});                                     
                                       }                               
                                       
                  }) .catch(function(error)
                  {
                          console.log(error.message);
                  });   
    }


    const onClickVerifyOtp=()=>
      {
               if((!inputs.fOtp) || inputs.fOtp ==='')
                {
                       toast.error("Please Fill OTP.",{ position: "bottom-right", autoClose: 4000, theme: "light"});          
                       return;
                }
                else
                {
                      //alert(fpOtp);
                      if(inputs.fOtp == fpOtp)
                      {
                                setShowFPDiv(true);
                                setShowRPDiv(false);
                      }
                      else
                      {
                                  toast.error("OTP not matched.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
                      }
                    
                    }

    }
    const onResetPassword=()=>
      {      
        
       if((!inputs.fnewPassword) || inputs.fnewPassword ==='')
         {
            toast.error("Please Fill New Password.",{ position: "bottom-right", autoClose: 4000, theme: "light"});          
            return;
        }
        else  if((!inputs.fconfirmPassword) || inputs.fconfirmPassword ==='')              
        {
            toast.error("Please Fill Confirm Password.",{ position: "bottom-right", autoClose: 4000, theme: "light"});          
            return;
        }
        else if(inputs.fnewPassword!=inputs.fconfirmPassword)
        {
            toast.error("New password and confirm password not matched.",{ position: "bottom-right", autoClose: 4000, theme: "light"});          
            return;
        }
        else
        {
                
                 var rurl="https://userauth.avtbharat.com/Authorization/MobileResetPassword";
                 const rparams = JSON.stringify({
                            
                            "MobileNumber" : inputs.fMobile,
                            "Password" : inputs.fnewPassword,
                            "ConfirmPassword" : inputs.fconfirmPassword                    
                    });

               axios.post(rurl, rparams,{
                "headers": {
                "content-type": "application/json",
                },
            })
            .then(function(response)
            { 
                    if(response.data.validStatus===true)
                     {
                            toast.success("Password changed successfully.",{ position: "bottom-right", autoClose: 4000, theme: "light"});
                            window.open("https://login.avtbharat.com/","_self");
                     }
                    else
                    {
                           toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});
                    }
             })
            .catch(function(error)
            {
                    console.log(error.message);
            });
          
         
        }

    }

     return ( 
      <>                  
                
            <div id="divforgetpassword" class="row" hidden={showFPDiv}>
            <div className="" >
             <div className="form-group"> Mobile Number
                  <input id="fMobile" autofocus="autofocus"  name="fMobile" type="text" required="required" style={{ height:"20px !important;" }} maxLength={10} className="form-control" value={inputs.fMobile} onChange={changeFPHandler}></input>
              </div>
               <div className="form-group" hidden={showResendOtpBtn}> Enter OTP
                  <input id="fOtp" autofocus="autofocus"  name="fOtp" type="text" required="required" className="form-control" maxLength={4}  value={inputs.fOtp} onChange={changeFPHandler}></input>
              </div>
              <div className="text-center">
                <button type="submit" name="sendotp" id="sendotp" hidden={showSendOtpBtn} onClick={onClickSendOtp} className="btn btn-primary2 w-100 mt-2">Send OTP</button>
                 <button type="submit" name="verifyotp" id="verifyotp" hidden={showResendOtpBtn}  onClick={onClickVerifyOtp} className="btn btn-primary2 w-100 mt-2">Verify OTP</button>
                 <button type="submit" name="resendotp" id="resendotp" hidden={showResendOtpBtn}  onClick={onClickResendOtp} className="btn btn-primary w-100 mt-2">Resend OTP</button>
                
                <br/>
                
                <br/>
              </div>
          </div>
            </div>
           <div id="divResetpassword" hidden={showRPDiv}>
            <div class="row">
            <div className="" >
             <div className="form-group"> New Password
                  <input id="fnewPassword" name="fnewPassword" autofocus="autofocus"   type="password" required="required" className="form-control" value={inputs.fnewPassword} onChange={changeFPHandler}></input>
              </div>
               <div className="form-group" > Confirm Password
                  <input id="fconfirmPassword" name="fconfirmPassword" autofocus="autofocus"   type="password" required="required" className="form-control" value={inputs.fconfirmPassword} onChange={changeFPHandler}></input>
              </div>
              <div className="text-center">
                <button type="submit" name="resetPasswordBtn" id="resetPasswordBtn" onClick={onResetPassword} className="btn btn-primary2 w-100 mt-2">Reset</button>             
                
                <br/>                
                <br/>
              </div>
          </div>
            </div>
            
           </div>
             <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
       </>       
       )}; 
   
export default ForgetPassword;
